import { render, staticRenderFns } from "./VenueAppFeatures.vue?vue&type=template&id=60a76d80&"
import script from "./VenueAppFeatures.vue?vue&type=script&lang=ts&"
export * from "./VenueAppFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./VenueAppFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports